import { useLingui } from "@lingui/react";

import { riskLevelText } from "../../i18n/enumText";
import type { RiskLevel } from "../../types";
import { RiskBadge } from "../common/RiskBadge";

/** Contract-level security risk badge (distinct from game difficulty). */
export function ContractRiskBadge({ riskLevel }: { riskLevel: RiskLevel }): JSX.Element {
  const { i18n } = useLingui();
  return <RiskBadge tone={riskLevel} label={i18n._(riskLevelText(riskLevel))} />;
}
